import { ActivitySource } from '../registry/activity-source'
import type { ActivitySourceName, RouterSubscribe } from '../types/activity-source'

const SIGNAL_INTERVAL_MS = 10_000

const LIVE_SESSION_ROUTE_PATTERN = /^\/(?:admin\/)?(?:group-classes|private-classes)\/[^/]+\/?$/

export function isLiveSessionRoute(pathname: string): boolean {
  return LIVE_SESSION_ROUTE_PATTERN.test(pathname)
}

export class LiveSessionPresenceSource extends ActivitySource {
  readonly name: ActivitySourceName = 'live-session-presence'

  private readonly routerSubscribe: RouterSubscribe
  private unsubscribeRouter: (() => void) | null = null
  private intervalId: ReturnType<typeof setInterval> | null = null

  constructor(routerSubscribe: RouterSubscribe) {
    super()
    this.routerSubscribe = routerSubscribe
  }

  protected setup(): void {
    this.unsubscribeRouter = this.routerSubscribe((state) => {
      this.handleLocationChange(state.location.pathname)
    })
  }

  protected teardown(): void {
    this.stopInterval()
    this.unsubscribeRouter?.()
    this.unsubscribeRouter = null
  }

  private handleLocationChange(pathname: string): void {
    if (isLiveSessionRoute(pathname)) {
      this.startInterval()
    } else {
      this.stopInterval()
    }
  }

  private startInterval(): void {
    if (this.intervalId !== null) return

    this.notify()
    this.intervalId = setInterval(() => {
      this.notify()
    }, SIGNAL_INTERVAL_MS)
  }

  private stopInterval(): void {
    if (this.intervalId === null) return

    clearInterval(this.intervalId)
    this.intervalId = null
  }
}
